import React, { ComponentType, PureComponent } from 'react';
import { wrapDisplayName } from 'recompose';
import { WlWindow } from 'typings/globals/cordova';
import { isWeb } from 'utils/platform';

declare const window: WlWindow;
export type platforms = 'pizza' | 'cordova' | 'server';
export function isExcluded(excludedPlatforms: platforms[]): boolean {
  const isServer = window.isPreRender && excludedPlatforms.includes('server');
  const platformName = isWeb() ? 'pizza' : 'cordova';
  return isServer || excludedPlatforms.includes(platformName);
}

const ExcludeOnPlatforms = function <T>(excludedPlatforms: platforms[]) {
  return (WrappedComponent: ComponentType<T>): ComponentType<T> => {
    return class ExcludeOnPlatformsInternal extends PureComponent<T> {
      static displayName = wrapDisplayName(
        WrappedComponent,
        'ExcludeOnPlatforms',
      );

      render() {
        if (isExcluded(excludedPlatforms)) {
          return null;
        }
        return <WrappedComponent {...this.props} />;
      }
    };
  };
};

export default ExcludeOnPlatforms;
